import React from 'react';
import Clock from './Clock';

function App() {
  return (
    <Clock />
  );
}

export default App;
